import { combineReducers } from 'redux';
import usersReducer from './userAuth';
import loggedUserEntityReducer from './loggedUserEntity';

export default combineReducers({
  userAuth: usersReducer,
  loggedUserEntity: loggedUserEntityReducer,
});
